<template>
    <van-cell-group class="cell-group-coupon flex" inset v-show="show == '0'">
        <div class="flex-item">
          认证即可获1000元科服券
        </div>
        <div class="coupon-code-box">
          <van-button class="btn-code" size="small" type="primary" @click="goCertificate">去完善</van-button>
          </div>
      </van-cell-group>
</template>
<script>
import { clickUrl } from '@/utils'

export default {
  name: "CouponGroup",
  props:{
    show:{
      type: String,
      default: '0'
    }
  },
  data(){
    return{
    }
  },
  mounted(){
      
  },
  methods:{
    goCertificate(){
      sessionStorage.setItem('couponUrl',location.href)
      clickUrl('/coupon/company_certificate')
    },
  }
}
</script>
<style lang="scss" scoped>
.cell-group-coupon{
  margin: 10px 0;
    line-height: 40px;
    border-radius: 8px;
    background: linear-gradient(180deg, #F8EAD0 0%, #FEB75B 100%);
    border: 0;
    padding: 0 12px;
    .coupon-code-box{
      display: flex;
      align-items: center;
      button{
        background: linear-gradient(180deg, #FFC400 0%, #FF8E04 100%);
        border-radius: 8px;
        border: 0;
        line-height: 40px;
        padding: 4px 13px !important;
        font-size: 14px;
        color: #fff;
      }
    }
}
</style>
